import { notification } from 'antd';
import API from '../api/jongjonan';

/**
 * Constants
 */

export const FETCHING = 'guests/FETCHING';
export const FETCHING_OK = 'guests/FETCHING_OK';
export const FETCHING_FAILED = 'guests/FETCHING_FAILED';


/**
 * Action Creators
 */
export function fetchGuests(params) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCHING });
            const guests = await API.fetchGuests(params);
            const { data, total, total_pages, per_page, current_page } = guests.data;
            dispatch({
                type: FETCHING_OK,
                data,
                total,
                totalPages: total_pages,
                perPage: per_page,
                currentPage: current_page
            });
        } catch (err) {
            dispatch({
                type: FETCHING_FAILED,
                err: err.response || err.message
            });
            notification.error({
                message: 'Error',
                description: err.message
            });
        }
    }
}


/**
 * Reducer
 */
const initialState = {
    error: false,
    isLoading: false,
    data: [],
    currentPage: 1,
    total: 0,
    totalPages: 0,
    perPage: 10
};

export default function guests(state = initialState, action) {
    switch (action.type) {
        case FETCHING:
            return {
                ...state,
                isLoading: true,
                error: false
            };

        case FETCHING_OK:
            const { data, total, totalPages, perPage, currentPage } = action;

            return {
                ...state,
                isLoading: false,
                error: false,
                data,
                total,
                totalPages,
                perPage,
                currentPage
            };

        case FETCHING_FAILED:
            return {
                ...state,
                isLoading: false,
                data: [],
                error: action.err
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/guests.js